export enum QuoteSourceTypes {
  CREATED_EXTERNALLY = 'created_externally',
  CREATED_IN_RAP = 'created_in_RAP',
  RESUMED_IN_RAP_FROM_FIND_USER = 'resumed_in_RAP_from_find_user',
  RESUMED_IN_RAP_FROM_OPEN_LEADS = 'resumed_in_RAP_from_open_leads',
}
